import { render } from "./ClientsPhones.vue?vue&type=template&id=769da4c2"
import script from "./ClientsPhones.vue?vue&type=script&lang=js"
export * from "./ClientsPhones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__